define('home/templates/genericCardFavorite',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return " no-image";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<a href=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.link : stack1), depth0))
    + "\"\nclass=\"discussion-image\"\ndata-link-name=\"image\"\ndata-link-out=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.signedLink : stack1), depth0))
    + "\"\ndata-thread-id=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.id : stack1), depth0))
    + "\">\n\n<img src=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.image : depth0)) != null ? stack1.src : stack1), depth0))
    + "\" alt=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.image : depth0)) != null ? stack1.title : stack1), depth0))
    + "\">\n</a>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<a class=\"card-avatar\" href=\"/by/"
    + alias2(alias1((depth0 != null ? depth0.username : depth0), depth0))
    + "/\" data-link-name=\"user_avatar\">\n<img\nsrc=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.avatar : depth0)) != null ? stack1.cache : stack1), depth0))
    + "\"\nalt=\""
    + ((stack1 = container.invokePartial(partials.userNameNoLink,depth0,{"name":"userNameNoLink","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "\" />\n</a>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression, alias3=container.lambda;

  return "<div class=\"card-discussion"
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.image : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n<div class=\"card-aside\">\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.image : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n<div class=\"card-body\">\n"
    + ((stack1 = helpers["with"].call(alias1,(depth0 != null ? depth0.firstActor : depth0),{"name":"with","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<div class=\"card-reason\">\n"
    + alias2(helpers.gettext.call(alias1,"%(group)s recommended",{"name":"gettext","hash":{"group":helpers.getPartial.call(alias1,"userGroupNames",{"name":"getPartial","hash":{},"data":data})},"data":data}))
    + "\non\n<a class=\"name-community\"\nhref=\"/home/forum/"
    + alias2(alias3(((stack1 = ((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.forum : stack1)) != null ? stack1.id : stack1), depth0))
    + "/\"\ndata-link-name=\"forum_name\"\ndata-forum-pk=\""
    + alias2(alias3(((stack1 = ((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.forum : stack1)) != null ? stack1.pk : stack1), depth0))
    + "\">\n\n"
    + ((stack1 = container.invokePartial(partials.forumName,((stack1 = (depth0 != null ? depth0.thread : depth0)) != null ? stack1.forum : stack1),{"name":"forumName","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</a>\n</div>\n"
    + ((stack1 = container.invokePartial(partials.threadTitle,depth0,{"name":"threadTitle","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "<div class=\"card-summary\">\n<div class=\"card-summary-content truncate\" data-truncate-lines=\"3\" dir=\"auto\">\n"
    + ((stack1 = alias3((depth0 != null ? depth0.threadDescriptionHTML : depth0), depth0)) != null ? stack1 : "")
    + "\n</div>\n</div>\n<footer class=\"card-footer\" data-role=\"footer\"></div>\n</div>\n</div>\n";
},"usePartial":true,"useData":true})

});
